import EyeCatcher from './EyeCatcher';

export default EyeCatcher;
